import type { Actor } from '@/entities'

export const getActorUserId = (actor: Actor | null | undefined): string =>
    actor?.type === 'user' ? actor.userId : actor?.type === 'contact' ? actor.user?.userId ?? '' : ''
